const Burger = () => {
  return (
    <svg viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 0H0V2H24V0Z" fill="currentColor" />
      <path d="M24 16H0V18H24V16Z" fill="currentColor" />
      <path d="M24 8H0V10H24V8Z" fill="currentColor" />
    </svg>
  );
};

export default Burger;
